export default {
  bool: 'b',
  int: 'i',
  float: 'f',
  time: 't'
}
